import { GET_CURRENT_COMPANY, Modal } from '@employ-engage/common-components';
import ManagementRolesForm from '../management-roles-form/management-roles-form';
import { useQuery } from '@apollo/client';
import { ManagementRole } from '@employ-engage/data';

export interface AddManagementRoleModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  refetchCompany: () => void;
  selectNewRole: (role: ManagementRole) => void;
}

export const AddManagementRoleModal = ({
  open,
  setOpen,
  selectNewRole,
}: AddManagementRoleModalProps) => {
  const {
    data: { currentCompany },
  } = useQuery(GET_CURRENT_COMPANY);
  return (
    <Modal open={open} setOpen={setOpen} panelClassName="w-full sm:w-1/2">
      <div className="p-6">
        <h2 className="text-2xl font-bold mb-4">Add Management Role</h2>
        <ManagementRolesForm
          managementRoles={currentCompany?.managementRoles || []}
          selectNewRole={selectNewRole}
        />
      </div>
    </Modal>
  );
};

export default AddManagementRoleModal;
